module.exports = __webpack_public_path__ + "static/img/car-01.ca12f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/car-01.jpg
// module id = EoBq
// module chunks = 0